/**
 * Custom JS class for handling vehicle carousels
 */
export default class Carousel {
  constructor(el, options) {
    this.el = el;
    this.prev = this.el.querySelector('.dealersite-slider__prev');
    this.next = this.el.querySelector('.dealersite-slider__next');
    this.images = this.el.querySelectorAll('.dealersite-slider__image');
    this.currentSlide = 0;
    this.slides = this.el.querySelectorAll('.dealersite-slider__container');
    this.slideCount = this.slides.length;
    this.options = options;

    this.prev.addEventListener('click', (event) => {
      this.slides.forEach((slide) => {
        slide.classList.remove('active');

        let index = parseInt(slide.dataset.index);
        if (index === this.slideCount - 1) {
          slide.dataset.index = '0';
        } else {
          slide.dataset.index = (index + 1).toString();
        }

        slide.querySelector('.dealersite-slider__content').classList.remove('active');
      });

      if (this.currentSlide === 0) {
        this.changeSlide(this.slideCount - 1);
        return;
      }

      this.changeSlide(this.currentSlide - 1);
    });

    this.next.addEventListener('click', (event) => {
      this.slides.forEach((slide) => {
        slide.classList.remove('active');

        let index = parseInt(slide.dataset.index);
        if (index === 0) {
          slide.dataset.index = (this.slideCount - 1).toString();
        } else {
          slide.dataset.index = (index - 1).toString();
        }

        slide.querySelector('.dealersite-slider__content').classList.remove('active');
      });

      if (this.currentSlide === this.slideCount - 1) {
        this.changeSlide(0);
        return;
      }

      this.changeSlide(this.currentSlide + 1);
    });

    let slide = (index) => {
      if (this.slideCount == 3) {
        if (index === 2) {
          this.prev.click();
        } else if (index === 1) {
          this.next.click();
        }
      } else if (this.slideCount == 4) {
        if (index == 3) {
          this.prev.click();
        } else if (index == 2) {
          this.next.click();
          this.next.click();
        } else if (index == 1) {
          this.next.click();
        }
      }
    };

    this.images.forEach(function (image) {
      image.addEventListener('click', (event) => {
        let dataIndex = event.target
          .closest('.dealersite-slider__container')
          .getAttribute('data-index');
        slide(dataIndex);
      });
    });
  }

  changeSlide(slideIndex) {
    this.currentSlide = slideIndex;
    this.slides[this.currentSlide].classList.add('active');
    this.slides[this.currentSlide]
      .querySelector('.dealersite-slider__content')
      .classList.add('active');
  }
}
